import React from 'react'

const LoandingArea = () => {
    return (
        <div id="loading-area"></div>
    )
}

export default LoandingArea
